import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6960b14c7683ed001472e800/ativanam_solutions/src/app/homepage/components/ClientTestimonials.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6960b14c7683ed001472e800/ativanam_solutions/src/app/homepage/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6960b14c7683ed001472e800/ativanam_solutions/src/app/homepage/components/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6960b14c7683ed001472e800/ativanam_solutions/src/app/homepage/components/ServiceSelector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6960b14c7683ed001472e800/ativanam_solutions/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/6960b14c7683ed001472e800/ativanam_solutions/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/6960b14c7683ed001472e800/ativanam_solutions/src/components/ui/AppImage.tsx");
